import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enables the brand-centric search page for logged in retailers
 */
export const BRAND_CENTRIC_SEARCH_250925 =
  'BRAND_CENTRIC_SEARCH_250925' as SettingConst<
    'BRAND_CENTRIC_SEARCH_250925',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
